export interface Category {
  name: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=white%20minimalist%20sneakers%20on%20light%20cream%20surface%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20simple%20elegant%20composition&width=400&height=400&seq=cat-shoes-v8&orientation=squarish',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=cozy%20beige%20hoodie%20folded%20neatly%20on%20light%20wooden%20surface%2C%20minimalist%20product%20photography%2C%20soft%20diffused%20lighting%2C%20warm%20cream%20and%20sand%20tones%2C%20clean%20aesthetic&width=400&height=400&seq=cat-hoodies-v8&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=crisp%20white%20cotton%20t-shirt%20neatly%20folded%20on%20light%20linen%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20daylight%2C%20warm%20neutral%20cream%20tones%2C%20clean%20simple%20composition&width=400&height=400&seq=cat-tshirts-v8&orientation=squarish',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    icon: 'ri-t-shirt-air-line',
    image: 'https://readdy.ai/api/search-image?query=stylish%20olive%20green%20bomber%20jacket%20on%20light%20oak%20hanger%2C%20minimalist%20fashion%20photography%2C%20soft%20natural%20lighting%2C%20warm%20earthy%20tones%2C%20clean%20professional%20aesthetic&width=400&height=400&seq=cat-jackets-v8&orientation=squarish',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    icon: 'ri-todo-line',
    image: 'https://readdy.ai/api/search-image?query=well%20tailored%20beige%20chinos%20folded%20on%20light%20surface%2C%20minimalist%20product%20photography%2C%20soft%20window%20lighting%2C%20warm%20cream%20and%20sand%20tones%2C%20clean%20catalog%20style&width=400&height=400&seq=cat-pants-v8&orientation=squarish',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    icon: 'ri-shield-user-line',
    image: 'https://readdy.ai/api/search-image?query=sleek%20minimal%20baseball%20cap%20in%20cream%20color%20on%20light%20surface%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20clean%20simple%20composition&width=400&height=400&seq=cat-headwear-v8&orientation=squarish',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=matching%20beige%20hoodie%20and%20joggers%20outfit%20set%20folded%20on%20light%20linen%2C%20minimalist%20fashion%20photography%2C%20soft%20daylight%2C%20warm%20sand%20and%20cream%20tones%2C%20clean%20catalog%20aesthetic&width=400&height=400&seq=cat-sets-v8&orientation=squarish',
  },
  {
    name: 'Underwear',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=soft%20cotton%20underwear%20basics%20neatly%20folded%20on%20light%20cream%20surface%2C%20minimalist%20product%20photography%2C%20gentle%20lighting%2C%20warm%20neutral%20tones%2C%20clean%20simple%20aesthetic&width=400&height=400&seq=cat-underwear-v8&orientation=squarish',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=sports%20jersey%20in%20cream%20and%20sage%20colors%20on%20light%20wooden%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20clean%20athletic%20aesthetic&width=400&height=400&seq=cat-jersey-v8&orientation=squarish',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    icon: 'ri-glasses-line',
    image: 'https://readdy.ai/api/search-image?query=minimalist%20sunglasses%20and%20gold%20watch%20on%20light%20cream%20surface%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20sand%20and%20cream%20tones%2C%20clean%20lifestyle%20aesthetic&width=400&height=400&seq=cat-accessories-v8&orientation=squarish',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    icon: 'ri-handbag-line',
    image: 'https://readdy.ai/api/search-image?query=stylish%20leather%20crossbody%20bag%20in%20warm%20tan%20color%20on%20light%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20cream%20and%20sand%20tones%2C%20clean%20professional%20aesthetic&width=400&height=400&seq=cat-bags-v8&orientation=squarish',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    icon: 'ri-contrast-drop-2-line',
    image: 'https://readdy.ai/api/search-image?query=premium%20leather%20belt%20with%20gold%20buckle%20on%20light%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20clean%20elegant%20composition&width=400&height=400&seq=cat-belts-v8&orientation=squarish',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=elegant%20glass%20perfume%20bottle%20on%20light%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20sand%20tones%2C%20clean%20sophisticated%20aesthetic&width=400&height=400&seq=cat-perfumes-v8&orientation=squarish',
  },
  {
    name: 'OtherStuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=assorted%20fashion%20accessories%20including%20scarf%20and%20wallet%20on%20light%20wooden%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20cream%20and%20beige%20tones%2C%20clean%20lifestyle%20aesthetic&width=400&height=400&seq=cat-other-v8&orientation=squarish',
  },
];